import { PermissionGroupMessages } from "src/languages/interfaces";

enum EPermissionGroupModule {
  GENERAL_REGISTRATION = "generalRegistration",
  SUPPLY = "supply",
  CONCRETE_RECIPE_FAMILY = "concreteRecipeFamily",
  ADMINISTRATION = "administration",
  SUPPLY_QUALITY = "supplyQuality",
  VEHICLES = "vehicles",
  EMPLOYEES = "employees",
  REPORT = "report",
  SETTINGS = "settings",
  EXPEDITION = "expedition",
  SCHEDULE = "schedule",
  USER_RIGHTS_CONTROL = "userRightsControl",
  BATCHPORTAL_MAINTENANCE_VIEW = "batchPortalMaintenanceView",
  BATCHPORTAL_MAINTENANCE_EDIT = "batchPortalMaintenanceEdit",
  BATCHPORTAL_MAINTENANCE_EXECUTE = "batchPortalMaintenanceExecute",
  BATCHPORTAL_AUTOMATION_VIEW = "batchPortalAutomationView",
  BATCHPORTAL_AUTOMATION_EXECUTE = "batchPortalAutomationExecute",
  BATCHPORTAL_AUTOMATION_ADMIN = "batchPortalAutomationAdmin",
  BATCHPORTAL_AUTOMATION_SUPER_ADMIN = "batchPortalAutomationSuperAdmin",
  DASHBOARD = "dashboard",
  LABORATORY = "laboratory"
}

const permissionGroupObject = {
  [EPermissionGroupModule.GENERAL_REGISTRATION]: {
    id: "1",
    title: PermissionGroupMessages.generalRegistration
  },
  [EPermissionGroupModule.SUPPLY]: {
    id: "2",
    title: PermissionGroupMessages.supply
  },
  [EPermissionGroupModule.CONCRETE_RECIPE_FAMILY]: {
    id: "3",
    title: PermissionGroupMessages.concreteRecipeFamily
  },
  [EPermissionGroupModule.SUPPLY_QUALITY]: {
    id: "4",
    title: PermissionGroupMessages.supplyQuality
  },
  [EPermissionGroupModule.ADMINISTRATION]: {
    id: "5",
    title: PermissionGroupMessages.administration
  },
  [EPermissionGroupModule.VEHICLES]: {
    id: "6",
    title: PermissionGroupMessages.vehicles
  },
  [EPermissionGroupModule.EMPLOYEES]: {
    id: "7",
    title: PermissionGroupMessages.employees
  },
  [EPermissionGroupModule.REPORT]: {
    id: "8",
    title: PermissionGroupMessages.report
  },
  [EPermissionGroupModule.SETTINGS]: {
    id: "9",
    title: PermissionGroupMessages.settings
  },
  [EPermissionGroupModule.EXPEDITION]: {
    id: "10",
    title: PermissionGroupMessages.expedition
  },
  [EPermissionGroupModule.SCHEDULE]: {
    id: "11",
    title: PermissionGroupMessages.schedule
  },
  [EPermissionGroupModule.USER_RIGHTS_CONTROL]: {
    id: "12",
    title: PermissionGroupMessages.userRightsControl
  },
  [EPermissionGroupModule.BATCHPORTAL_MAINTENANCE_VIEW]: {
    id: "13",
    title: PermissionGroupMessages.batchPortalMaintenanceView
  },
  [EPermissionGroupModule.BATCHPORTAL_MAINTENANCE_EDIT]: {
    id: "14",
    title: PermissionGroupMessages.batchPortalMaintenanceEdit
  },
  [EPermissionGroupModule.BATCHPORTAL_MAINTENANCE_EXECUTE]: {
    id: "15",
    title: PermissionGroupMessages.batchPortalMaintenanceExecute
  },
  [EPermissionGroupModule.BATCHPORTAL_AUTOMATION_VIEW]: {
    id: "16",
    title: PermissionGroupMessages.batchPortalAutomationView
  },
  [EPermissionGroupModule.BATCHPORTAL_AUTOMATION_EXECUTE]: {
    id: "17",
    title: PermissionGroupMessages.batchPortalAutomationExecute
  },
  [EPermissionGroupModule.BATCHPORTAL_AUTOMATION_ADMIN]: {
    id: "18",
    title: PermissionGroupMessages.batchPortalAutomationAdmin
  },
  [EPermissionGroupModule.BATCHPORTAL_AUTOMATION_SUPER_ADMIN]: {
    id: "19",
    title: PermissionGroupMessages.batchPortalAutomationSuperAdmin
  },
  [EPermissionGroupModule.DASHBOARD]: {
    id: "20",
    title: PermissionGroupMessages.dashboard
  },
  [EPermissionGroupModule.LABORATORY]: {
    id: "21",
    title: PermissionGroupMessages.laboratory
  }
};

export { EPermissionGroupModule, permissionGroupObject };